import React from "react";
import { Link } from "react-router-dom";
import "./style.scss";

const ComponentBridge__RequiredJoin = (props) => {
    return (<div className="component-bridge-required-join text-center leading-text">
        <span className="image-box square">
            <img src={process.env.PUBLIC_URL + '/assets/image/bridge/bridge-logo-square.svg'} alt="Sign in with Microsoft"   />
        </span>
        <h1 className="font-semibold text-md">Join the Initiative Project?</h1>
        <p className="text-sm mt-lg ">
            To participate in this initiative project, you need to be registered as a research member on BINUS BRIDGE.
        </p>
        <p className="mt-md mb-md">
            BINUS BRIDGE is the official platform for research collaboration and project management within the BINUS community.
        </p>
        <a className="btn btn-block btn-small btn-primary" href="https://binus.ac.id/bridge">Go To BINUS BRIDGE</a>
    </div>)
}

const ComponentBridge__HomeBanner = () => {
    return (
        <div className="component-bridge-home-banner">
            <div className="text-intro max-w-640">
                <h3 className="text-3xl font-semibold leading-loose mb-md">Crowdbees x BINUS BRIDGE</h3>
                <p className="leading-text mb-lg">
                    Crowdbees now connects you with industry challenges from BRIDGE, ready to be explored and solved by BINUS students, faculty, and staff.
                </p>
                <Link to='/research
                ' className="btn btn-white">View Opportunities</Link>
            </div>
            <span className="image-box square contain">
                <img src={process.env.PUBLIC_URL + '/assets/image/bridge/bridge-collaboration-illustration.png'} alt="Bridge Collab"   />
            </span>
        </div>
    )
}

const ComponentBridge__InsideBanner = () => {
    return (
        <div className="component-bridge-inside-banner">
            <span className="ornaments absolute inset" style={{backgroundImage : `url(${process.env.PUBLIC_URL}/assets/ornament/ornament-1.png)`}}></span>
            <div className="container">
                <div>
                    <span className="image-box square">
                        <img src={process.env.PUBLIC_URL + '/assets/image/bridge/bridge-logo-square.svg'} alt="Sign in with Microsoft"   />
                    </span>
                </div>
                <div className="banner-text leading-text">
                    In partnership with BINUS BRIDGE, this project connects real-world industry needs with the creative power of the BINUS community.
                </div>
            </div>
        </div>
    )
}

export {ComponentBridge__RequiredJoin, ComponentBridge__HomeBanner, ComponentBridge__InsideBanner}